import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { tap, takeUntil, filter, takeWhile } from 'rxjs/operators';

import { ShipmentService } from '../shipment.service';
import { EnumsService, Preferences } from '@library/core/services';
import { FormGroup } from '@angular/forms';

@Component({
   selector: 'shipment-customs',
   templateUrl: './customs.component.html',
   styleUrls: ['./customs.component.scss']
})
export class CustomsComponent implements OnInit, OnDestroy {

   _onDestroy: Subject<void> = new Subject();
   isQuote: any;
   customsFg: FormGroup;
   customsForm: any;
   valueForm: any;
   currencyForm: any;

   constructor(
      public shipment: ShipmentService,
      public enums: EnumsService,
      private prefs: Preferences,
   ) { }

   ngOnInit() {
      this.shipment.shipmentForm$.pipe(
         takeWhile( s => s.contains( 'customs' )),
         takeUntil( this._onDestroy ),
      ).subscribe( shipmentForm => {
         this.isQuote = shipmentForm.get('isQuote');
         const customs = shipmentForm.get( 'customs' ) as FormGroup;
         const currency = customs.get( 'currency' );
         
         if ( this.isQuote.value ) {
            customs.removeControl('value');
            customs.removeControl('currency');
            customs.updateValueAndValidity();
         } else {
            customs.get( 'value' ).valueChanges.pipe(
               tap( value => !value ? currency.reset() : null ),
               filter( value => !!value ),
               takeUntil( this._onDestroy ),
            ).subscribe( _ =>
               currency.setValue( currency.value ?? this.prefs.getPref( 'currency' )));
         }
      });
   }

   ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
   }

}
